import { message } from 'antd';
import dayjs from 'dayjs';
import FormHelpers from '../../../../helpers/FormHelpers';

const ERROR_MESSAGES = {
  requiredField: (fieldName) => `Error in ${fieldName} field. Select/Enter a valid value then proceed.`,
};

// Utility to validate document-level errors
const validateDocLevelFields = ({
  selectedSeller, invoiceNumber, selectedGRNForAPInvoice, cfAPInvoiceDoc, apInvoiceDate,
  apInvoiceType, selectedGRNValue, match, ewayBillNumber,
  apInvoiceTableData, ewayBillList, vendorAddress, user, invoiceDate, selectedTenant, apInvoiceNumber,
}) => {
  const errors = [];

  const LineTotal = (tableData, typeValue) => {
    let totalAmount = 0;

    if (tableData?.length > 0) {
      for (let i = 0; i < tableData.length; i++) {
        const quantityToUse = typeValue === 'ADHOC'
          ? tableData[i]?.quantity
          : tableData[i]?.ap_received_qty;

        if (quantityToUse && tableData[i]?.offer_price) {
          totalAmount += quantityToUse * tableData[i].offer_price;
        }
      }
    }

    return { totalAmount };
  };

  if (!apInvoiceNumber) {
    errors.push({
      name: 'AP Invoice Number',
      value: '',
      message: ERROR_MESSAGES.requiredField('AP Invoice Number'),
    });
  }

  if (!selectedSeller && !match?.params?.apiId && !selectedGRNForAPInvoice) {
    errors.push({
      name: 'Customer',
      value: '',
      message: ERROR_MESSAGES.requiredField('Select Vendor'),
    });
  }

  if (!vendorAddress) {
    errors.push({
      name: "Vendor's Address",
      value: '',
      message: ERROR_MESSAGES.requiredField("Vendor's Address"),
    });
  }

  if (apInvoiceType === 'GRN' && !selectedGRNValue && !match?.params?.apiId && !selectedGRNForAPInvoice) {
    errors.push({
      name: 'GRN',
      value: '',
      message: ERROR_MESSAGES.requiredField('Select Order'),
    });
  }
  if (apInvoiceType === 'ADHOC' && !selectedTenant && !match?.params?.apiId && !selectedGRNForAPInvoice) {
    errors.push({
      name: 'Location',
      value: '',
      message: ERROR_MESSAGES.requiredField('Select Location'),
    });
  }

  // if (
  //   !invoiceNumber
  // ) {
  //   errors.push({
  //     name: 'Invoice Number',
  //     value: '',
  //     message: ERROR_MESSAGES.requiredField('Vendor Invoice#'),
  //   });
  // }

  if (!apInvoiceDate) {
    errors.push({
      name: 'AP Invoice Date',
      value: '',
      message: ERROR_MESSAGES.requiredField('AP Invoice Date'),
    });
  }
  // if (allowGRNDateBeforeInvoiceDate
  //   && dayjs(apInvoiceDate).isValid()
  //   && dayjs(invoiceDate).isValid()
  //   && dayjs(apInvoiceDate).isBefore(dayjs(invoiceDate))) {
  //   errors.push({
  //     name: 'GRN Date',
  //     value: '',
  //     message: 'Error in The GRN date cannot be earlier than the invoice date. Please verify the entered dates.',
  //   });
  // }

  if (
    // user?.tenant_info?.purchase_config?.sub_modules?.goods_receiving_note?.settings?.is_e_way_bill_mandatory
    // &&
    LineTotal(apInvoiceTableData, apInvoiceType).totalAmount >= 50000
  ) {
    if (!ewayBillNumber) {
      errors.push({
        name: 'e-Way Bill number',
        value: '',
        message: ERROR_MESSAGES.requiredField('e-Way Bill number'),
      });
    }

    if (!ewayBillList || (ewayBillList?.length === 0)) {
      errors.push({
        name: 'e-Way Bill Attachment',
        value: '',
        message: ERROR_MESSAGES.requiredField('e-Way Bill Attachment'),
      });
    }
  }

  if (cfAPInvoiceDoc) {
    cfAPInvoiceDoc.forEach((field) => {
      if (field?.isRequired && field?.isActive) {
        errors.push({
          name: field?.fieldName,
          value: field?.fieldValue,
          message: ERROR_MESSAGES.requiredField(field?.fieldName),
        });
      }
    });
  }

  return errors;
};

// Utility to validate line-level errors
const validateLineLevelFields = ({
  apInvoiceTableData, cfAPInvoiceLine, apInvoiceType,
}) => {
  const errors = [];

  if (apInvoiceTableData && (apInvoiceType === 'GRN')) {
    apInvoiceTableData.forEach((item) => {
      if (cfAPInvoiceLine) {
        item?.lineCustomFields?.filter((field) => field?.fieldName !== 'Quantity' && field?.fieldName !== 'Rate')?.forEach((field) => {
          if (field.isRequired && field?.isActive) {
            errors.push({
              name: field?.fieldName,
              value: field?.fieldValue,
              message: ERROR_MESSAGES.requiredField(`${field?.fieldName} for Product '${item?.product_sku_info?.internal_sku_code || ''}`),
            });
          }
        });
      }

      if (!item?.offer_price || item?.offer_price == 0) {
        errors.push({
          name: 'Cost Price',
          value: 0,
          message: ERROR_MESSAGES.requiredField(`Product "${item?.product_sku_info?.internal_sku_code}'s" Unit Price`),
        });
      }

      if (!item?.taxInfo) {
        errors.push({
          name: 'Tax',
          value: 0,
          message: ERROR_MESSAGES.requiredField(`Product "${item?.product_sku_info?.internal_sku_code}'s" Tax`),
        });
      }

      if (Number(item?.ap_received_qty) === 0) {
        errors.push({
          name: 'Received Quantity',
          value: 0,
          message: ERROR_MESSAGES.requiredField(`Product "${item?.product_sku_info?.internal_sku_code}'s" Received`),
        });
      }
    });
  }

  if (apInvoiceTableData && (apInvoiceType === 'ADHOC')) {
    apInvoiceTableData.forEach((item) => {
      if (!item?.product_sku_info) {
        errors.push({
          name: 'Product',
          value: '',
          message: 'Select a Product to continue',
        });
      } else {
        if (!item?.offer_price || item?.offer_price == 0) {
          errors.push({
            name: 'Cost Price',
            value: 0,
            message: ERROR_MESSAGES.requiredField(`Product "${item?.product_sku_info?.internal_sku_code}'s" Unit Price`),
          });
        }

        if (!item?.taxInfo) {
          errors.push({
            name: 'Tax',
            value: 0,
            message: ERROR_MESSAGES.requiredField(`Product "${item?.product_sku_info?.internal_sku_code}'s" Tax`),
          });
        }

        if (cfAPInvoiceLine) {
          item?.lineCustomFields?.filter((field) => field?.fieldName !== 'Quantity' && field?.fieldName !== 'Rate')?.forEach((field) => {
            if (field.isRequired && field?.isActive) {
              errors.push({
                name: field?.fieldName,
                value: field?.fieldValue,
                message: ERROR_MESSAGES.requiredField(`${field?.fieldName} for Product '${item?.product_sku_info?.internal_sku_code || ''}`),
              });
            }
          });
        }
      }

      if (Number(item?.quantity) === 0) {
        errors.push({
          name: 'Received Quantity',
          value: 0,
          message: ERROR_MESSAGES.requiredField(`Product "${item?.product_sku_info?.internal_sku_code}'s" Quantity`),
        });
      }
    });
  }

  return errors;
};

// Main function to get packing slip error list
const apiErrorList = (params) => {
  const docLevelErrors = validateDocLevelFields(params);
  const lineLevelErrors = validateLineLevelFields(params);

  return FormHelpers.errorChecker({ docLevelErrors, lineLevelErrors });
};

export default apiErrorList;
